export default __webpack_public_path__ + "static/media/saint_aubin6.704d1207.jpg";